// extracted by css-extract-rspack-plugin
export default {"cls1":"PostComments-cls1_qRL","cls2":"PostComments-cls2_gSa PostComments-cls1_qRL"};